import React, { Component } from 'react';


export default class CircularDependencies extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    getMapping(id) {
        if (this.props.selectedEntity.activities) {
            for (let i = 0; i < this.props.selectedEntity.activities.length; i++) {
                let activity = this.props.selectedEntity.activities[i];
                if (id.toString() === activity._id.toString()) {
                    return activity.name;
                }
                if (activity.activities) {
                    for (let j = 0; j < activity.activities.length; j++) {
                        let subActivity = activity.activities[j];
                        if (id.toString() === subActivity._id.toString()) {
                            return activity.name + " > " + subActivity.name;
                        }
                        if (subActivity.activities) {
                            for (let k = 0; k < subActivity.activities.length; k++) {
                                let childActivity = subActivity.activities[k];
                                if (childActivity) {
                                    if (id.toString() === childActivity._id.toString()) {
                                        return activity.name + " > " + subActivity.name + " > " + childActivity.name;
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }
    }
    removeAllDependencies = async () => {
        let ids = [];
        for (let i = 0; i < this.props.selectedEntity.cycles.length; i++) {
            ids.push(this.props.selectedEntity.cycles[i][this.props.selectedEntity.cycles[i].length - 1])
        }
        await this.props.fixAction(ids);
        this.setState({ circularDependencies: false })
    }
    manualAction = () => {
        if (this.props.manualAction) {
            this.props.manualAction();
        }
    }
    render() {
        return (
            <div>
                <div>
                    <span style={{ color: this.props.color ? this.props.color : "" }}>{this.props.selectedEntity.cycles.length} Circular dependencies found. {!this.props.showActions && <span>&nbsp;Select following actions to continue</span>}
                        {this.props.showActions && <span className='text-right pull-right'>
                            {this.props.manualAction && <span><span className="clr-blue circular-dependency-action cursor-pointer" onClick={this.manualAction}>Fix Manually</span>
                                <span className="text-muted">|</span></span>}
                            <span className="clr-red circular-dependency-action  cursor-pointer" onClick={this.removeAllDependencies}>Remove All</span>
                        </span>}
                    </span>
                </div>

                <div >
                    {
                        this.props.selectedEntity.cycles.map((cycle, index) => {
                            return <div className="dependencies-block" key={index}>
                                <span>Dependency {index + 1}</span>
                                {cycle.map((activity, i) => {
                                    return <div key={i} className="dependency-activity">{this.getMapping(activity)}</div>
                                })}
                            </div>
                        })
                    }
                </div>
            </div>
        );
    }
}
